import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import ErrorSvg from '../../assets/error.svg'

export default function NotFound({ fullScreen = true }) {
  const error = useRouteError()

  const wrapperStyles = `
    flex items-center justify-center flex-col
    ${fullScreen ? 'min-h-screen py-12' : 'mt-10 py-16'}
    bg-gradient-to-br from-blue-100 to-indigo-50 relative
  `

  return isRouteErrorResponse(error) && error.status === 404 ? (
    <div className={wrapperStyles}>
      <div className="relative max-w-md w-full mx-auto">
        {/* Decorative elements */}
        <div className="absolute -top-10 -left-10 w-20 h-20 bg-indigo-400 rounded-full opacity-20"></div>
        <div className="absolute -bottom-12 -right-4 w-32 h-32 bg-blue-400 rounded-full opacity-20"></div>

        {/* Main card */}
        <div className="backdrop-blur-xl bg-white/30 border border-white/50 rounded-2xl p-8 md:p-12 shadow-2xl text-center relative z-10 overflow-hidden">
          {/* 404 Text */}
          <h1 className="text-8xl md:text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 tracking-tight leading-none">
            404
          </h1>

          {/* Badge */}
          <div className="inline-block rounded-full bg-gradient-to-r from-orange-400 to-rose-500 px-4 py-1 text-sm font-medium text-white shadow-lg transform -rotate-2 my-4">
            Page Not Found
          </div>

          {/* Message */}
          <p className="text-slate-700 mt-4 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Button */}
          <a
            href="/"
            className="group relative inline-flex items-center justify-center overflow-hidden rounded-lg bg-gradient-to-br from-indigo-500 to-blue-500 p-0.5 text-sm font-medium text-white hover:text-white focus:outline-none focus:ring-4 focus:ring-blue-300"
          >
            <span className="relative rounded-md bg-white px-6 py-3 transition-all duration-75 ease-in group-hover:bg-opacity-0 text-indigo-600 group-hover:text-red-600 font-medium flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Back to Home
            </span>
          </a>
        </div>
      </div>
    </div>
  ) : (
    <div className={wrapperStyles}>
      <div className="backdrop-blur-xl bg-white/30 border border-white/50 rounded-2xl p-8 shadow-2xl max-w-md w-full text-center relative z-10">
        <img src={ErrorSvg} alt="Error" className="h-52 md:h-64 mx-auto mb-6" />
        <h2 className="text-2xl font-bold text-slate-800 mb-2">Oops! Something went wrong</h2>
        <p className="text-slate-600 mb-6">
          We encountered an unexpected error. Please try refreshing the page or come back later.
        </p>
        <div className="flex justify-center gap-4">
          <button
            onClick={() => window.location.reload()}
            className="px-5 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium flex items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            Refresh
          </button>
          <a
            href="/"
            className="px-5 py-2 border border-indigo-600 text-indigo-600 rounded-lg hover:bg-indigo-50 transition-colors font-medium"
          >
            Go Home
          </a>
        </div>
      </div>
    </div>
  )
}
